import '../../css/ButtonCom/ButtonSkewAni.css'

function ButtonSkew() {
	return (
		<div>
			<a href="#" className='ButtonSkewbutton'>
				CLICK HERE!
			</a>
		</div>
	)
}

export default ButtonSkew;